var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmcg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4109 13.2109H5.03237L2.64268 34.6367C2.59992 35.0176 2.6383 35.4031 2.75531 35.7683C2.87232 36.1335 3.06531 36.4696 3.32157 36.7548C3.5785 37.0394 3.89285 37.2665 4.24389 37.4208C4.59493 37.5754 4.9747 37.6537 5.35822 37.6507H31.8618C32.2454 37.6537 32.6252 37.5754 32.9764 37.4208C33.3273 37.2665 33.6416 37.0394 33.8985 36.7548C34.1548 36.4696 34.3478 36.1335 34.465 35.7683C34.5818 35.4031 34.6203 35.0176 34.5774 34.6367L33.2002 22.2889",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8213 13.211V9.13774C11.8213 7.33721 12.5365 5.61046 13.8097 4.33729C15.0828 3.06413 16.8096 2.34888 18.6102 2.34888C20.4107 2.34888 22.1374 3.06413 23.4106 4.33729C24.6838 5.61046 25.399 7.33721 25.399 9.13774V9.83781",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7437 15.7237L25.3822 9.8396L31.4415 10.6104L37.3743 19.542L29.6765 24.6553L23.7437 15.7237Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmcg);
export default __webpack_public_path__ + "static/media/FMCG.a00b7632871a217c8e696774563c2817.svg";
export { ForwardRef as ReactComponent };